const slideToggle = (element) => {
  if (element.style.display === 'none' || element.style.display === '') {
    element.style.display = 'block';
    if (element.closest('.cust-accordion').classList.contains('desc-tab-wrapper')) {
      element.closest('.cust-accordion').classList.add('active');
    }
  } else {
    element.style.display = 'none';
    if (element.closest('.cust-accordion').classList.contains('desc-tab-wrapper')) {
      element.closest('.cust-accordion').classList.remove('active');
    }
  }
}

const disSlider = () => {
  let disslideshowEle = document.querySelectorAll('.discount-wrap.slider-wrapper');
  if (disslideshowEle) {
    disslideshowEle.forEach(current => {
      let swiperOptions = JSON.parse(current.dataset.sliderOptions);
      swiperOptions = {
        ...swiperOptions,
        pagination: {
          el: '.swiper-pagination.product-index',
          type: 'fraction',
          formatFractionCurrent: function (number) {
            return ('0' + number).slice(-1);
          },
          formatFractionTotal: function (number) {
            return ('0' + number).slice(-1);
          },
          renderFraction: function (currentClass, totalClass) {
            return '<span class="' + currentClass + '"></span>' +
              '/' +
              '<span class="' + totalClass + '"></span>';
          }
        }
      };
      swiper = new Swiper(current, swiperOptions);

      // pause slideshow on block select
      if (Shopify.designMode) {
        document.addEventListener('shopify:block:select', (e) => {
          let shopifyData = JSON.parse(e.target.dataset.shopifyEditorBlock),
            targetEle = e.target,
            sliderIndex = 1 + parseInt(targetEle.dataset.swiperSlideIndex);
          swiper.slideTo(sliderIndex);
          swiper.autoplay.stop();
        })
        const customizationEvents = ['shopify:inspector:activate', 'shopify:inspector:deactivate', 'shopify:section:load', 'shopify:block:deselect', 'shopify:section:reorder', 'shopify:section:select', 'shopify:section:deselect', 'shopify:inspector:activate', 'shopify:inspector:deactivate'];

        customizationEvents.forEach(event => {
          document.addEventListener(event, () => swiper.init(swiperOptions));
        })
      }
    })
  }
}

const faqClick = () => {
  const queBtn = document.querySelectorAll('.que');
  if (queBtn) {
    queBtn.forEach(function (el) {
      el.addEventListener('click', function (e) {
        let newID = e.currentTarget.getAttribute('data-sequece');
        var all = document.querySelectorAll('.ans');
        queBtn.forEach(function (data) {
          data.classList.remove('active');
        });

        all.forEach(function (answer) {
          if (answer.id !== newID) {
            answer.style.display = 'none';
          }
        });
        const ans = document.querySelector(`#${newID}`);
        if (ans.style.display === 'none' || ans.style.display === '') {
          ans.style.display = 'block';
          e.currentTarget.classList.add('active');
        } else {
          ans.style.display = 'none';
          e.currentTarget.classList.remove('active');
        }
      });
    })
  }
}

// const customDropDown = () => {
//   var dropDownBtn = document.querySelectorAll('.el-dropdown-btn');
//   if (dropDownBtn) {
//     // toggle dropdown
//     dropDownBtn.forEach(btn => {
//       btn.addEventListener('click', (e) => {
//         var dropDownList =  e.currentTarget.nextElementSibling;
//         dropDownList.classList.toggle('active');
//       })
//     })

//     // apply/change value
//     let dropDownList = document.querySelectorAll('.el-dropdown-list li');
//     if (dropDownList.length > 0) {
//       dropDownList.forEach(btn => {
//         btn.addEventListener('click', (e) => {
//           let that = e.currentTarget;
//           let inputField = that.closest('.el-dropdown').querySelector('input[type="hidden"]');
//           that.closest('ul').querySelectorAll('li').forEach(input => input.classList.remove('active'));
//           that.classList.add('active');
//           inputField.value = that.getAttribute('value');
//           inputField.dispatchEvent(new Event('change'));
//         })
//       })
//     }

//     //  close mobile popup
//     let closeBtn = document.querySelectorAll('.el-dropdown .closePop,.el-dropdown .overlay');
//     if (closeBtn.length > 0) {
//       closeBtn.forEach(btn => {
//         btn.addEventListener('click', (e) => {
//           let that = e.currentTarget;
//           that.closest('.el-dropdown').querySelector('.el-dropdown-list').classList.remove('active');
//         })
//       })
//     }

//   }
// }


if (!customElements.get('custom-dropdown')) {
  class customDropDown extends HTMLElement {
    constructor() {
      super();
      this.init();
    }
    onClick = () => {
      const dropDownBtn = this.querySelectorAll('.el-dropdown-btn');
      if (dropDownBtn) {
        // toggle dropdown
        dropDownBtn.forEach(btn => {
          btn.addEventListener('click', (e) => {
            const dropDownList = e.currentTarget.nextElementSibling;
            dropDownList.classList.toggle('active');
          })
        })

        // apply/change value
        let dropDownList = this.querySelectorAll('.el-dropdown-list li');
        if (dropDownList.length > 0) {
          dropDownList.forEach(btn => {
            btn.addEventListener('click', (e) => {
              let that = e.currentTarget;
              let inputField = that.closest('.el-dropdown').querySelector('input[type="hidden"]');
              that.closest('ul').querySelectorAll('li').forEach(input => input.classList.remove('active'));
              that.classList.add('active');
              inputField.value = that.getAttribute('value');
              inputField.dispatchEvent(new Event('change'));
            })
          })
        }

        //  close mobile popup
        let closeBtn = this.querySelectorAll('.el-dropdown .closePop,.el-dropdown .overlay');
        if (closeBtn.length > 0) {
          closeBtn.forEach(btn => {
            btn.addEventListener('click', (e) => {
              let that = e.currentTarget;
              that.closest('.el-dropdown').querySelector('.el-dropdown-list').classList.remove('active');
            })
          })
        }
      }
    }
    init = () => {
      this.onClick();
    }
  }
  customElements.define('custom-dropdown', customDropDown)
}



// Infinite scroll
const infiniteScroll = () => {
  let cacheCount = 0;
  window.addEventListener('scroll', () => {
    let infiniteWrapperEle = document.querySelector('[data-next-page]');
    if (infiniteWrapperEle) {
      let offsetBottom = infiniteWrapperEle.getBoundingClientRect().bottom - window.innerHeight;
      let rootMargin = window.innerHeight * 2;
      if (offsetBottom <= rootMargin && cacheCount == 0) {
        cacheCount++;
        let url = infiniteWrapperEle.dataset.nextPage;
        if (url != "") {
          fetch(url)
            .then(res => res.text())
            .then(data => {
              cacheCount = 0;
              var dataHTML = new DOMParser().parseFromString(data, 'text/html');
              let productGrid = dataHTML.querySelector('[data-next-page]').innerHTML;

              infiniteWrapperEle.insertAdjacentHTML("beforeend", productGrid);

              infiniteWrapperEle.dataset.nextPage = dataHTML.querySelector('[data-next-page]').dataset.nextPage;
              theme.sizesChart();
              // window.history.pushState("Dennis lingo", "Dennis lingo", url);
              if (window.AOS) { AOS.refreshHard() }
            })
        } else {
          document.querySelector('.pagination-loader').style.display = "none";
        }
      }
    }
  })
}

const mobileFilter = () => {
  const isopenitem = document.querySelectorAll('.js-drawer-open-collection-filters');
  if (isopenitem) {
    isopenitem.forEach(function (param) {
      param.addEventListener('click', (btn) => {
        const Openitem = param.getAttribute('data-is-open');

        const isopenitemchild = document.querySelectorAll('.collapsible-trigger-btn');
        isopenitemchild.forEach(function (param1) {
          const Openitemchild = param1.getAttribute('data-is-open');
          if (Openitemchild == Openitem) {
            param1.classList.add('is-open');
          } else {
            param1.classList.remove('is-open');
          }
        });

        const isopenitemGrandchild = document.querySelectorAll('.collapsible-content');
        isopenitemGrandchild.forEach(function (param) {
          const OpenitemGrandchild = param.getAttribute('data-is-open');

          if (Openitem == OpenitemGrandchild) {
            param.classList.add('is-open');
          } else {
            param.classList.remove('is-open');
            param.style.height = '0px';
          }
        });
      });
    });
  }
}

const collectionRating = () => {
  var badgeElement = document.querySelectorAll('.coll_rating .jdgm-prev-badge');
  if (badgeElement) {
    badgeElement.forEach(function (item) {
      var averageRating = item.getAttribute('data-average-rating');
      var numberOfReviews = item.getAttribute('data-number-of-reviews');

      if (averageRating != '0.00') {
        var convertInnum = parseFloat(averageRating);
        var newNum = convertInnum.toFixed(1);
        item.parentElement.nextElementSibling.innerHTML = `<div class="rating_inner"><span class="icon"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" height="15px" width="15px" version="1.1" id="Capa_1" viewBox="0 0 47.94 47.94" xml:space="preserve">
        <path style="fill:var(--jdgm-star-color);" d="M26.285,2.486l5.407,10.956c0.376,0.762,1.103,1.29,1.944,1.412l12.091,1.757  c2.118,0.308,2.963,2.91,1.431,4.403l-8.749,8.528c-0.608,0.593-0.886,1.448-0.742,2.285l2.065,12.042  c0.362,2.109-1.852,3.717-3.746,2.722l-10.814-5.685c-0.752-0.395-1.651-0.395-2.403,0l-10.814,5.685  c-1.894,0.996-4.108-0.613-3.746-2.722l2.065-12.042c0.144-0.837-0.134-1.692-0.742-2.285l-8.749-8.528  c-1.532-1.494-0.687-4.096,1.431-4.403l12.091-1.757c0.841-0.122,1.568-0.65,1.944-1.412l5.407-10.956  C22.602,0.567,25.338,0.567,26.285,2.486z"></path>
        </svg></span>${newNum} <span class="reviewNumber">${numberOfReviews}</span></div>`;
      }
    });
  }
}



//Loader on clear all
// const loaderClearAll = () => {
//   var clearAllButton = document.querySelectorAll('.clear-all');
//   var loader = document.querySelectorAll('.page-loader');
//   clearAllButton.forEach(function(el) {
//     setTimeout(() => {
//       el.addEventListener('click', () => {
//         console.log('hello');
//         loader.forEach(function(clearall) {
//           clearall.style.display = "block";
//         });
//       });
//     }, 5000);
//   });
// }


window.theme = window.theme || {};

theme.sliderDesktop = () => {
	if (window.innerWidth > 768) {
		for (item of document.querySelectorAll('.desktop_slids .desktop_slids_inner > div'))
			item.style.scrollSnapAlign = 'center';

		const gallery = document.querySelectorAll('.desktop_slids');
		gallery.forEach(btn => {
			const gallery_scroller = btn.querySelector('.desktop_slids_inner');
			const gallery_item_size = gallery_scroller.querySelector('div').clientWidth;

			btn.querySelector('.btn.next').addEventListener('click', scrollToNextPage);
			btn.querySelector('.btn.prev').addEventListener('click', scrollToPrevPage);

			function scrollToNextPage() {
				gallery_scroller.scrollBy(gallery_item_size, 0);
			}
			function scrollToPrevPage() {
				gallery_scroller.scrollBy(-gallery_item_size, 0);
			}
		});

	}
}


theme.sizesChart = () => {
  setTimeout(() => {
    const sizeChart = document.querySelectorAll('.sizeOnclicking');
    if (sizeChart) {
      sizeChart.forEach(function (item) {
        item.style.display = 'flex';
        item.addEventListener('click', function (e) {
          this.classList.add('active');
          var gridProductContent = e.currentTarget.closest('.grid-product__content');
          gridProductContent.querySelector('.size-infos').classList.add('show-popup', 'active');
          gridProductContent.querySelector('.overlay-popup').classList.add('active');
          document.body.classList.add('size_guide_open');
        });
      });
    }
  }, 2000);
  setTimeout(() => {
    const sizeClose = document.querySelectorAll('.close-icon');
    if (sizeClose) {
      sizeClose.forEach(function (item) {
        item.addEventListener('click', function (e) {
          var sizeInfos = e.currentTarget.closest('.size-infos');
          sizeInfos.classList.remove('active', 'show-popup');
          e.currentTarget.closest('.overlay-popup').classList.remove('active');
          e.currentTarget.closest('.overlay-popup').previousElementSibling.querySelector('.sizeOnclicking').classList.remove('active');
          document.body.classList.remove('size_guide_open');
        });
      });
    }
  }, 2000);
}

window.addEventListener('DOMContentLoaded', () => {
  disSlider();
  faqClick();
  mobileFilter();
  collectionRating();
  // loaderClearAll();
  infiniteScroll();
  const accoridanContent = document.querySelectorAll('.cust-accordion .acco-title');
  if (accoridanContent) {
    accoridanContent.forEach(function (element) {
      element.addEventListener('click', function (e) {
        e.preventDefault();
        this.toggleAttribute('active');
        slideToggle(this.nextElementSibling);
      });
    });
  }

  if (window.innerWidth <= 768) {
    const reviewContent = document.querySelector('.cust-accordion .acco-review-title');
    if (reviewContent) {
      reviewContent.addEventListener('click', function (e) {
        e.preventDefault();
        this.toggleAttribute('active');
        slideToggle(this.nextElementSibling);
      });
    }
  }



  const descaccoridanContent = document.querySelector('.cust-accordion .acco-desc-title');
  if (descaccoridanContent) {
    descaccoridanContent.addEventListener('click', function (e) {
      e.preventDefault();
      this.toggleAttribute('active');
      slideToggle(this.nextElementSibling);
    });
  }
  // // discount-code js
  // document.querySelectorAll('.success-msg-main').forEach(success => {
  //   success.style.display="none";
  // })
  // document.querySelectorAll('.discount-code-desc-inner').forEach(offer => {
  //   offer.addEventListener('click', (e) => {
  //     var current = e.currentTarget;
  //     var nextcurrent = e.currentTarget.nextElementSibling;
  //     var loaderclass = e.currentTarget.previousElementSibling;
  //     var discount_code = e.currentTarget.getAttribute('data-id');
  //     loaderclass.style.display = "flex";
  //     current.style.display="none";
  //  fetch(`/discount/${discount_code}`,{
  //       method: 'GET',
  //     })
  //     .then(response => {
  //       loaderclass.style.display="none";
  //       current.style.display = "none";
  //       nextcurrent.style.display = "block";
  //         const closeData = document.querySelector('body .product-single__meta');
  //       if(closeData){
  //         const newforsm = document.querySelector('#CartDrawerForm');
  //         cartFormFa = new theme.CartForm(newforsm);
  //         cartFormFa.buildCart();
  //       }
  //       setTimeout(function() {
  //         current.style.display = "block";
  //         nextcurrent.style.display = "none";
  //       }, 4000);
  //     })
  //   })
  // });

  theme.sizesChart();
	theme.sliderDesktop();

  // customDropDown();

});


// Disable cart button if no variant is selected
let cartBtnWrap = document.querySelector('.product-single__form');
if (cartBtnWrap) {
  let cartBtn = cartBtnWrap.querySelector('[data-add-to-cart]');
  let buyBtn = cartBtnWrap.querySelector('.shopify-payment-button');
  let variantCheck = document.querySelectorAll('.product-single__meta .variant-input-wrap input[type="radio"]');
  let lengthVar = document.querySelectorAll('.variant-selectors .variant-wrapper .variant-input-wrap');

  function isVariantSelected() {
    let selectedVariants = Array.from(variantCheck).filter(variant => variant.checked);
    console.log('selectedVariants: ', selectedVariants);
    return selectedVariants.length === lengthVar.length;
  }

  cartBtn.addEventListener('click', (event) => {
    if (!isVariantSelected()) {
      event.preventDefault();
      document.querySelector('.variant-selectors').scrollIntoView({
        behavior: 'smooth'
      });
      document.querySelector('.err_mes_size').innerHTML = 'Please select a size option';
    }
    else {
      document.querySelector('.err_mes_size').innerHTML = '';
    }
  });
  // buyBtn.addEventListener('click', (event) => {
  //   if (!isVariantSelected()) {
  //     event.preventDefault();
  //     event.stopPropagation();  
  //     document.querySelector('.variant-selectors').scrollIntoView({
  //       behavior: 'smooth'
  //     });
  //     document.querySelector('.err_mes_size').innerHTML = 'Please select a size option';
  //   }
  //   else {
  //     document.querySelector('.err_mes_size').innerHTML = '';
  //   }
  // });
}

// add product grid variant to localstorage
setTimeout(() => {
  let prd_grid = document.querySelectorAll('.grid-product__content .size_var_wrap a');
  if (prd_grid) {
    prd_grid.forEach((prdVar) => {
      prdVar.addEventListener('click', (event) => {
        event.preventDefault();
        let prdId = prdVar.closest('.grid__item').dataset.productId;
        console.log(prdId,'prdId');
        let variantUrl = prdVar.getAttribute('data-navigation');
        let selectedValue = prdVar.getAttribute('data-var');
        if (prdId && selectedValue && variantUrl) {
          const items = {
            product_id: prdId,
            selected_var: selectedValue
          }
          const stringifiedObj = JSON.stringify(items)
          localStorage.setItem("prd_grid_variant", stringifiedObj);
          setTimeout(() => {
            window.location.href = variantUrl;
          }, 100);
        }
      })
    })
  }
}, 3000);


// if user arrives from grid item then select a variant:::
let getVariant = localStorage.getItem("prd_grid_variant");
if (getVariant) {
  let variantObj = JSON.parse(getVariant);
  let productId = variantObj.product_id;
  let productVar = variantObj.selected_var;
  let currentPrd = document.querySelectorAll('.variant-selectors .variant-wrapper .variant-input');
  if (currentPrd) {
    currentPrd.forEach((productVariant) => {
      let curr_prd_id = productVariant.closest('.product-section').dataset.productId;
      let variants = productVariant.getAttribute('data-value');
      if (curr_prd_id == productId && variants == productVar) {
        // click variant selected from Grid Item...
        productVariant.click();
        productVariant.querySelector('input[type="radio"]').click();
        // change size in drop-down...
        // let sizeDrpDwn = document.querySelector('floating-cart .size_name');
        // sizeDrpDwn.textContent = productVar;

        // var flobuy_now_grid = document.querySelector('#flo-buy-now-button');
        // var error_now_grid = document.querySelector('.error_inSize');
        // if (window.getComputedStyle(flobuy_now_grid).display === "none") {
        //   flobuy_now_grid.style.display = "block";
        //   error_now_grid.style.display = "none";
        // }
      }
    })
  }
}

// ATC from cartDrawer
const drawerAtcBtn = document.querySelectorAll('[drawer-atc-btn]');
if (drawerAtcBtn) {
  drawerAtcBtn.forEach((btn) => {
    btn.addEventListener('click', (event) => {
      event.preventDefault();
      let errDiv = btn.closest('.product-content-inner').querySelector('.no_var_selected');
      // check if variant is selected or not
      let isVarSelected = btn.getAttribute('data-variant-id');
      if (isVarSelected) {
        errDiv.innerHTML = "";
        handleAtc(isVarSelected);
      }
      else {
        errDiv.innerHTML = "Please select a size option";
      }
    })
  })
}

// handle ATC
const handleAtc = (variant_id) => {
  if (variant_id) {
    console.log('variant_id: ', variant_id);
    fetch('/cart/add.js', {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: variant_id, quantity: 1 })
    })
      .then(res => res.json())
      .then(res => {
        let cart_drawer = document.querySelector('#CartDrawerForm');
        let cart_form = new theme.CartForm(cart_drawer);
        cart_form.buildCart();
      })
  }
}

// drawer variant change JS
let selectedRadioArray = [];
const radioButtons = document.querySelectorAll('#CartDrawer .upsell_inner input[type="radio"]');
if (radioButtons) {
  radioButtons.forEach((radioButton) => {
    radioButton.addEventListener("change", () => {
      selectedRadioArray = Array.from(radioButton.closest('.upsell_inner').querySelectorAll('input[type="radio"]:checked')).map(radio => radio.value);
      const variantsInfo = radioButton.closest('.size_var_wrap').querySelector('[drawer-products-json]').textContent.trim();
      const productData = JSON.parse(variantsInfo);
      const prdVar = productData.variants;
      const selectedVariant = prdVar.find(variant => selectedRadioArray.includes(variant.option2));
      const variantId = selectedVariant.id;
      const atcBtn = radioButton.closest('.product-content-inner').querySelector('[drawer-atc-btn]');
      atcBtn.setAttribute('data-variant-id', variantId);
    });
  });
}